<template>
  <v-dialog v-model="localShow"
            max-width="300px" >
    <v-card>

      <v-card-text style="text-align: center;font-size: 20px;color: black">
       {{options.message}}
      </v-card-text>

      <v-progress-linear
          height="15"
          indeterminate
          color="deep-purple accent-4">

      </v-progress-linear>

    </v-card>

  </v-dialog>

</template>

<script>

    export default {
      name:'Progress',
      props: {
        isShow:Boolean,
        params: Object
      },
        data() {
            return {
              localShow: this.isShow,
                options: {
                    message: '',
                }
            }

        },


      mounted () {
        this.$root.$on('Progress', () => {
         this.localShow=false;
        })},
      created() {
        Object.assign(this.options, this.params)
        }
    }
</script>

